import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { Link } from "react-router-dom";
import { ProtectedRoutes } from "../../types/Routes";
import HideBalanceBtn from "./HideBalanceBtn";
import { useAppStore } from "../../store/store";

const AccountDropDown = () => {
  const hideAccountBalance = useAppStore((state) => state.hideAccountBalance);
  const setDrawerType = useAppStore((state) => state.setDrawerType);
  const setIsDrawerOpen = useAppStore((state) => state.setIsDrawerOpen);
  const setHideAccountBalance = useAppStore(
    (state) => state.setHideAccountBalance,
  );
  return (
    <Menu>
      <MenuButton className="h-[42px] w-[42px] rounded-[8px] border-[1px] border-grey flex items-center justify-center cursor-pointer group/dropdown">
        <BiDotsVerticalRounded className="group-hover/dropdown:rotate-[-45deg]" />
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className="!p-2 w-[250px] !shadow-md mt-2 absolute bg-white rounded-md z-50 origin-top transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
      >
        <MenuItem>
          <div className="uppercase text-[14px] 2xl:text-[16px] font-[400] py-2 px-4 text-brand-textLightGrey Nunito bg-transparent hover:bg-white cursor-default">
            <span>Accounts</span>
          </div>
        </MenuItem>
        <MenuItem>
          <div
            className="!px-4 !py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito hover:!bg-brand-yellow hover:!text-brand-darkYellow transition cursor-pointer"
            onClick={() => {
              setDrawerType("deposit");
              setIsDrawerOpen(true);
            }}
          >
            <span>Deposit Funds</span>
          </div>
        </MenuItem>
        <MenuItem>
          <Link
            to={ProtectedRoutes.ACCOUNT}
            className="!px-4 !py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito hover:!bg-brand-yellow hover:!text-brand-darkYellow transition block cursor-pointer"
          >
            <div className="">
              <span>Add Account</span>
            </div>
          </Link>
        </MenuItem>
        <MenuItem>
          <div
            className="!px-4 !py-2 rounded-[4px] text-[14px] 2xl:text-[16px] Nunito hover:!bg-brand-yellow hover:!text-brand-darkYellow transition cursor-pointer"
            onClick={() => {
              setDrawerType("withdraw");
              setIsDrawerOpen(true);
            }}
          >
            <span>Withdraw</span>
          </div>
        </MenuItem>
        <MenuItem>
          <div
            onClick={() => {
              setHideAccountBalance(!hideAccountBalance);
              localStorage.setItem(
                "hideAccountBalance",
                JSON.stringify(!hideAccountBalance),
              );
            }}
          >
            <HideBalanceBtn />
          </div>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default AccountDropDown;
